import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { PartialRollsetRow } from "../models/PartialRollsets";

export interface GetPartialRollsetsParams {
	signal?: AbortSignal;
}

export const getPartialRollsetsData = async ({
	signal,
}: GetPartialRollsetsParams): Promise<PartialRollsetRow[]> => {
	const apiService = new MESApiService();
	// The procedure takes no params: the grid sorts and pages client-side.
	const spName = "[ROLLS].[GetPartialRollsets]";
	const parameters: spParameter[] = [];
	const resp = await apiService.callV2(spName, parameters, signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching partial rollsets");
	}
	return get(resp, "data.tables[0].rows", []) as PartialRollsetRow[];
};
